import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import BffApiService from '@/shared/bffApiService';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { useBffRequest } from '@/hooks/useBffRequest';
import { selectUserBtag } from '@/store/selectors/combined.selectors';

export function useMobileNumberVerificationRequired(): {
  mobileNumberVerificationRequired: boolean;
} {
  const { request } = useBffRequest(BffApiService.mobileNumberVerificationRequired);
  const btag = useSelector(selectUserBtag);
  const locale = useSelector(selectLocale);

  const [mobileNumberVerificationRequired, setMobileNumberVerificationRequired] = useState(false);

  useEffect(() => {
    if (btag && btag.length > 0) {
      request({
        axiosConfig: { params: { btag: btag } },
        pathParams: {
          btag,
        },
        successCallback: data => {
          setMobileNumberVerificationRequired(data?.isMobileNumberVerificationRequired ?? false);
        },
      });
    }
  }, [locale, btag]);

  return { mobileNumberVerificationRequired };
}
